export default __webpack_public_path__ + "static/media/the-annex-cafe.de633e5f.jpg";